export type * from 'features/generator/services/private/qrCodesApi'
export {
	buildDisabledRedirectUrl,
	qrCodesApi,
} from 'features/generator/services/private/qrCodesApi'
